import React from 'react';
import { galleryCategories, galleryImages } from '../data/gallery';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';

/**
 * Editorial, large-format gallery. One lead photograph carries the section,
 * the rest follow in an asymmetric rhythm so the land reads as a place
 * rather than a uniform tile grid.
 */
export function Gallery() {
  const [lead, ...rest] = galleryImages;
  return <section id="gallery" className="scroll-mt-20 bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-354" data-mp="2polntt3t685k">
      <div className="mx-auto max-w-6xl" data-id="element-355" data-mp="2kp8tknalxysy">
        <div className="mb-10 flex flex-col gap-6 md:mb-14 md:flex-row md:items-end md:justify-between" data-id="element-356" data-mp="2kme7krby45xf">
          <div data-id="element-357" data-mp="2zfg9owd575qh">
            <FadeIn data-id="element-358" data-mp="2umn8ujksohjo">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-359" data-mp="2um56d57jh73b">
                Gallery
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-360" data-mp="26uzmmeyh9unq">
              <h2 className="max-w-xl font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-361" data-mp="21yhlrq69qggo">
                The land, in photographs.
              </h2>
            </FadeIn>
          </div>
          <FadeIn delay={0.2} data-id="element-362" data-mp="wbe77dmko7h9">
            <p className="max-w-sm text-sm leading-relaxed text-clay/80 md:text-right" data-id="element-363" data-mp="wambm2sz69qz">
              {galleryCategories.join(' · ')}
            </p>
          </FadeIn>
        </div>

        <FadeIn data-id="element-364" data-mp="1547nnedr9cwp">
          <figure className="mb-3 overflow-hidden rounded-sm md:mb-4" data-id="element-365" data-mp="152o67kgd4vtc">
            <SafeImage src={lead.src} fallbackSrc={lead.fallback} alt={lead.alt} className="h-[52vh] w-full object-cover md:h-[72vh]" data-id="element-366" data-mp="8e8fhl1iogen" />
          </figure>
        </FadeIn>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-12 md:gap-4" data-id="element-367" data-mp="hctvp9jinjc9">
          {rest.map((image, index) => {
          const spans = ['md:col-span-7', 'md:col-span-5', 'md:col-span-4', 'md:col-span-4', 'md:col-span-4', 'md:col-span-6', 'md:col-span-6'];
          return <FadeIn key={image.src} delay={Math.min(index, 4) * 0.05} className={`col-span-1 ${spans[index] ?? 'md:col-span-6'}`} data-id="element-368" data-mp="3tu6uhcits2dc" data-mpi={index}>
                <figure className="h-full overflow-hidden rounded-sm" data-id="element-369" data-mp="7o1kovg6am3k">
                  <SafeImage src={image.src} fallbackSrc={image.fallback} alt={image.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-370" data-mp="2p7665p8njp9" />
                </figure>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}